import { render, staticRenderFns } from "./LanguageSwitcherModal.vue?vue&type=template&id=be20c61c&scoped=true"
import script from "./LanguageSwitcherModal.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcherModal.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcherModal.vue?vue&type=style&index=0&id=be20c61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be20c61c",
  null
  
)

export default component.exports